/**
 * Component header-default JS
 */

jQuery(document).ready(function () {
    const component = jQuery('.header-default');

    if (!component.length) {
        return;
    }

    // const headerDefaultElement = document.querySelector('header.header-default');
    // const headerDefaultObserver = new IntersectionObserver(
    //    ([e]) => {
    //        return e.target.classList.toggle("is-sticked", e.intersectionRatio < 1);
    //    },
    //    {threshold: [1],}
    // );
    // headerDefaultObserver.observe(headerDefaultElement);


    jQuery('.header-default__icon a', component).bind('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        jQuery('body, .header-default, .common-menu-mobile').toggleClass('is-menu-open');
    });

});